var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54 5.54a.65.65 0 0 1 .92 0L8 9.08l3.54-3.54a.65.65 0 1 1 .92.92l-4 4a.65.65 0 0 1-.92 0l-4-4a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU0MDM5IDUuNTQwMzhDMy43OTQyMyA1LjI4NjU0IDQuMjA1NzggNS4yODY1NCA0LjQ1OTYzIDUuNTQwMzhMOC4wMDAwMSA5LjA4MDc2TDExLjU0MDQgNS41NDAzOEMxMS43OTQyIDUuMjg2NTQgMTIuMjA1OCA1LjI4NjU0IDEyLjQ1OTYgNS41NDAzOEMxMi43MTM1IDUuNzk0MjIgMTIuNzEzNSA2LjIwNTc4IDEyLjQ1OTYgNi40NTk2Mkw4LjQ1OTYzIDEwLjQ1OTZDOC4yMDU3OCAxMC43MTM1IDcuNzk0MjMgMTAuNzEzNSA3LjU0MDM5IDEwLjQ1OTZMMy41NDAzOSA2LjQ1OTYyQzMuMjg2NTUgNi4yMDU3OCAzLjI4NjU1IDUuNzk0MjIgMy41NDAzOSA1LjU0MDM4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";